import { ChangeEvent, FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../Checkbox';

type IProps = {
  onChange: (e: any) => void;
  id: string;
};
const NotificationsEnabled: FC<IProps> = ({ onChange, id }) => {
  // Hooks
  const { t }: Translation = useTranslation();
  const [notificationsEnabledCheckbox, setNotificationsEnabledCheckbox] = useState<boolean>(false);

  const notificationsEnabledText = useMemo(() => {
    return <>{t('acceptNotification')}</>;
  }, []);

  // Actions
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setNotificationsEnabledCheckbox(e.target.checked);
    onChange(e);
  };

  return (
    <Checkbox
      onChange={handleOnChange}
      label={notificationsEnabledText}
      id={id}
      name="notificationsEnabled"
      value={notificationsEnabledCheckbox}
    />
  );
};
export default NotificationsEnabled;
